module.exports = __webpack_public_path__ + "static/media/S (22).0a702b43.jpg";